// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { formatTime } from '@seedplanner/shared-utils';
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '../../lib/base';

type OrderContainerData = {
  time: number;
};

export default function SelectOverdueOrders({
  orders,
  timezone,
  selectedTimes,
  setSelectedTimes,
}: {
  readonly orders: OrderContainerData[];
  readonly timezone: string;
  readonly selectedTimes: number[];
  readonly setSelectedTimes: (orders: number[]) => void;
}) {
  const ordersWithFormats = orders.map((order) => ({
    ...order,
    formattedTime: formatTime(order.time, { timezone }),
  }));

  const ordersWithLabels = ordersWithFormats.map((order) => ({
    ...order,
    label: order.formattedTime,
  }));

  return (
    <>
      <Typography>Select which of the following overdue orders to create:</Typography>
      <ul>
        {ordersWithLabels.map((order) => {
          return (
            <SelectOrder
              isSelected={selectedTimes.includes(order.time)}
              onSelectOrder={(isSelected) => {
                const updatedSelectedOrders = isSelected
                  ? [...selectedTimes, order.time]
                  : selectedTimes.filter((id) => id !== order.time);
                setSelectedTimes(updatedSelectedOrders);
              }}
              key={order.time}
              order={order}
              label={order.label}
            />
          );
        })}
      </ul>
    </>
  );
}

function SelectOrder({
  order,
  label,
  isSelected,
  onSelectOrder,
}: {
  readonly order: OrderContainerData;
  readonly label: string;
  readonly isSelected: boolean;
  readonly onSelectOrder: (isSelected: boolean) => void;
}) {
  const onChangeSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelectOrder(e.target.checked);
  };

  return (
    <li key={order.time}>
      <Box display="flex" flexDirection="row" alignItems="center">
        <FormControlLabel
          sx={{ margin: 0, '& .MuiFormControlLabel-label': { flex: 1 } }}
          label={label}
          control={<Checkbox checked={isSelected} onChange={onChangeSelected} />}
          labelPlacement="start"
        />
      </Box>
    </li>
  );
}
